import { useState, useEffect} from "react"
import {Container, Row, Col} from "react-bootstrap";

import headerImg from "../assets/img/header-img.svg";
export const Banner = () => {
  const [loopNum, setLoopNum]= useState(0);
  const [isDeleting, setIsDeleting]= useState(false);
  const toRotate = ["Full Stack Developer","Web Designer","UI/UX Designer"];
  const [text, setText]= useState('');
  const [delta, setDelta]=useState(300 - Math.random()*100);
  const period =2000;

  useEffect(() => {
    let ticker =setInterval(() =>{
      tick();
    },delta)
    return () =>{clearInterval(ticker)};
  },)

  const tick = ()=>{
    let i= loopNum%toRotate.length;
    let fullText= toRotate[i];
    let updatedText=isDeleting ? fullText.substring(0, text.length-1) : fullText.substring(0,text.length +1);

    setText(updatedText);

    if(isDeleting){
      setDelta(prevDelta => prevDelta/2)
    }

    if(!isDeleting && updatedText === fullText){
      setIsDeleting(true)
      setDelta(period)
    }
    else if(isDeleting && updatedText===""){
      setIsDeleting(false);
      setLoopNum(loopNum+1);
      setDelta(500);
    }
  }

  return (
    <section className="banner" id="home">
      <Container>
        <Row className='align-items-center'>
          <Col xs={12} md={6} xl={7}>
          <span className="tagline">Welcome to my Portfolio-Verse</span>
          <h1>{`Hi I'm Sunil`}<span className="wrap"> a {text}</span></h1>
          <p>A Full Stack developer, with hands on experience in MERN Full Stack, Version Control and Docker. Looking forward to work on some real world problems and solve them. Keen to expand my knowledge on emerging technologies...</p>
          <p>Apart from being a developer, I love listening to music and playing guitar...</p> 
          </Col>
          <Col xs={12} md={6} xl={5}>
            <img src={headerImg} alt="Header Img" />
        
          </Col>
        </Row>
      </Container>
    </section>
  );
};
